import register from '@kpsys/angularjs-register';
import {FileDataService} from './file.data-service';
import {FileContentDataService} from './file-content.data-service';
import {FileService} from './file.service';

export default register('portaro.features.file')
    .service(FileContentDataService.serviceName, FileContentDataService)
    .service(FileDataService.serviceName, FileDataService)
    .service(FileService.serviceName, FileService)
    .name();